import Vue from 'vue'
import {mapState} from 'vuex'
import axios from '../utils/axiosinstance'
// import axios from 'axios'

Vue.mixin({

  computed: {
    ...mapState({
      currentproject: state => state.current.project,
      currentuser: state => state.current.user
    }),
  },

  methods: {
    getCurrentUser(user_id) {
      let _this = this
      axios.post(process.env.VUE_APP_BASE_AMF_URL + `getUsers&token=` + localStorage.sessiontoken, {
        "methodName": "getUsersOfProject",
        "serviceName": "ProjectdocuService",
        "parameters": [
          this.$route.params.id
        ]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
          if (response.status == 200) {
            response.data.forEach(function(val, idx) {
              // console.log('RunTrhoughData', val)
              if(val.pduserid == user_id) {
                _this.$store.commit('setCurrentUser', val)
              }
            })
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          // console.log('Refetched current User')
          $('.spinner-cover').hide()
        })
    },

    getCurrentuserObj() {
      if(typeof this.currentuser !== 'object' || this.currentuser.pduserid == undefined) {

        this.getCurrentUser(localStorage.user_id)
        // this.getCurrentUser(localStorage.user_id)
      }

      return this.currentuser

    },

    getCurrentProject() {
      let _this = this
      axios.post(process.env.VUE_APP_BASE_AMF_URL + `getProject&token=` + localStorage.sessiontoken, {
        "methodName": "getProject",
        "serviceName": "ProjectdocuService",
        "parameters": [
          this.$route.params.id
        ]
      }, {
        headers: {
          apitoken: localStorage.apikey,
          deviceid: localStorage.deviceid,
          accept: 'application/json'
        }
      }).then(response => {
          if (response.status == 200) {
            _this.$store.commit('setCurrentProject', response.data[0])
          }
        })
        .catch(error => console.log(error))
        .finally(() => {
          // console.log('Refetched current Project')
          $('.spinner-cover').hide()
        })
    },


    usercan (needed) {

      if(typeof this.currentuser !== 'object' || this.currentuser.pduserid == undefined) {

        this.getCurrentUser(localStorage.user_id)
        // this.getCurrentUser(localStorage.user_id)
      }

      if(typeof this.currentproject !== 'object' || this.currentproject.projectid == undefined){
        this.getCurrentProject()
      }
      // console.log('UserCan', needed, this, localStorage.user_id, this.currentuser, this.currentproject)
      // if(localStorage.user_id == 10) return false

      let user = this.currentuser
      let project = this.currentproject

      if(needed == 'test') {
        return false
      }


      if(project.isAdmin || project.rights == '1') {
        return true
      }


      if(needed == 'admin') {
        if(project.rights == "1") return true
      } else if(needed == 'editor') {
        if(project.rights == "2" || project.rights == "1") return true
      } else {
        // is guest
      }

      return false

    }
  }
})



// WEBPACK FOOTER //
// ./src/mixins/globalMethods.js